import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class RprismEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITRPRISM;
}